import apiClient from '@/services/axios'

export async function del(surveySessionId) {
  var response = await apiClient.delete('/venueVisitSessions/' + surveySessionId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete survey session.')
}